import { Component, Directive, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { IconComponent } from 'components/layout/icon/icon.component';
import { PanelComponent } from 'components/layout/panel/panel.component';
import { ComponentUrl } from 'services/navigation.service';

@Component({
	selector: 'soft-popup',
	templateUrl: './soft-popup.component.html',
	imports: [IconComponent, PanelComponent]
})
@ComponentUrl('soft-popup.component')
export class SoftPopupComponent {

	@ViewChild('wrapper') wrapper?: ElementRef<HTMLDivElement>;

	@Input() id?: string = undefined;
	@Input() width = 240;
	@Input() left = 0;
	@Input() top = 0;
	@Input() title = '';

	styleLeft?: number;
	styleTop?: number;

	private _showPopup = false;
	@Input()
	set showPopup(show: boolean) {
		this._showPopup = show;
		if (!show)
			return;
		this.setStyle();
	}
	get showPopup() {
		return this._showPopup;
	}

	constructor(private readonly element: ElementRef<HTMLElement>) {
		this.setStyle();
	}

	setStyle(rerunIfNoWrapperElement = true) {
		let height = this.wrapper?.nativeElement.offsetHeight ?? 0;
		
		this.styleTop = Math.min(this.top, window.innerHeight - height - 10) + 5;
		this.styleLeft = Math.min(this.left, window.innerWidth - this.width - 10) + 5;

		if (this.wrapper) return;
		if (rerunIfNoWrapperElement) setTimeout(() => this.setStyle(false), 0);

	}

	setShowPopup(e: MouseEvent) {
		this.left = e.clientX;
		this.top = e.clientY;
		this.showPopup = true;
	}
	 
	close(target?: any) {
		if (!target || (target && !this.element.nativeElement.contains(target))) {
			this.showPopup = false;
		}
	}
}

@Directive({ selector: '[trigger-soft-popup]' })
export class TriggerSoftPopupDirective {
	@Input('trigger-soft-popup') softPopup?: SoftPopupComponent;

	@HostListener('click', ['$event'])
	click(event: MouseEvent): void {
		if (!this.softPopup) return;
		this.softPopup.setShowPopup(event);
		event.stopPropagation();
	}
}
